import styles from 'styles/modules/popUps/Alert.module.scss';
import Button from 'components/Button';

export default function PaymentAlert(props) {
    const { isActive, alertTitle, alertMessage, onCancel } = props;

    return (
        <div
            className={[styles.wrapper, isActive ? styles.isActive : null].join(
                ' '
            )}
        >
            <div className={[styles.popUp]}>
                <h4 className={styles.title}>{alertTitle}</h4>
                <p>{alertMessage}</p> <br /> <br /> <br />
                <Button title={'Continue'} onClick={onCancel} />
            </div>
        </div>
    );
}
